import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { FlexGrid } from 'yoso';
import { categoryAdditionalInfo } from '~/components/Help/Help.helpers';
import { useHelpCategories } from '~/components/Help/Help.hooks';
import { HelpCategoryCard } from '../Card';
import styles from './HelpCategoryNav.module.scss';

const EVENT_MAP: Record<number, string> = {
  20009798: 'General',
  20009939: 'Membership',
  20009917: 'Purchases',
  20009918: 'Payments',
  20009800: 'Others',

  // NOTE: PREVIEW environment
  50003987: 'General',
  50003988: 'Membership',
  50003989: 'Purchases',
  50003990: 'Payments',
  50003991: 'Others',
};

export type HelpCategoryNavProps = {
  className?: string;
};

export const HelpCategoryNav = ({ className }: HelpCategoryNavProps) => {
  const { data = [], isLoading } = useHelpCategories();
  return (
    <FlexGrid container className={classNames(styles.root, className)}>
      {!isLoading &&
        data.map((category) => {
          const { categoryId } = category;
          const additionalInfo = categoryAdditionalInfo[EVENT_MAP[categoryId]];
          return (
            <FlexGrid key={categoryId} className={styles.item}>
              <Link to={`/support/help/category/${categoryId}`}>
                <HelpCategoryCard {...category} {...additionalInfo} />
              </Link>
            </FlexGrid>
          );
        })}
    </FlexGrid>
  );
};
